module.exports = __webpack_public_path__ + "common/icon_plus-f2c347a97b6b178401b32e88bddf3c9b.svg";